import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';
import {
	useSelector,
} from 'react-redux';

import SitemapsTable from './SitemapsTable';

import {
	loadData as loadSitemaps,
	selector as sitemapsSelector,
} from '~/state/inaccessibleSitemaps';



const messages = defineMessages({
	statusCode: {
		id: 'ui.contentOverview.tableHeading.status_code',
	},
	url: {
		id: 'ui.screen.sitemapsList.headings.sitemap.label',
	},
});



type Props = {
	tableWidth: number,
};

const InaccessibleSitemapsTable: React.FC<Props> = (props) => {
	const {
		tableWidth,
	} = props;

	const sitemaps = useSelector(sitemapsSelector);

	return (
		<SitemapsTable
			columns={[
				{
					render: {
						cell: ({ row }) => row.url,
						header: () => <FormattedMessage {...messages.url} />,
					},
					width: 450,
				},
				{
					render: {
						cell: ({ row }) => row.status_code,
						header: () => <FormattedMessage {...messages.statusCode} />,
					},
					width: 450,
				},
			]}
			loadData={loadSitemaps}
			sitemaps={sitemaps}
			tableWidth={tableWidth}
		/>
	);
};



export default InaccessibleSitemapsTable;
